import "./forgot-password-form.scss";
import Logo from 'assets/authentication/amorino-logo.svg'

import { useFormik } from "formik";
import * as Yup from "yup";
import { FormState } from "../login/login";
import ColorButton from "../color-button/color-button";
import { StringStore } from "StringStore";
import { useDispatch, useSelector } from "react-redux";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { auth0SendPasswordReset } from "../../authSlices";

const validationSchema = Yup.object().shape({
  email: Yup.string().required("Required"),
  emailAgain: Yup.string().required("Required"),
});

interface ForgotPasswordFormProps {
  email: string;
  emailAgain: string;
}

const ForgotPasswordForm = ({ setFormState }) => {
  const dispatch: Function = useDispatch();
  const isEmailSent = useSelector((state: any) => state.auth.isEmailSent);
  const formik = useFormik<ForgotPasswordFormProps>({
    initialValues: {
      email: "",
      emailAgain: "",
    },
    validateOnMount: true,
    validationSchema,
    onSubmit: ({ email }) => {
      dispatch(auth0SendPasswordReset(email));
      setFormState(FormState.Login);
    },
  });

  const handleClick = (state: FormState) => {
    setFormState(state)
  }

  const isSameValidEmails = () => {
    const isSameEmails = formik.values.email === formik.values.emailAgain;
    const isEmailValid = formik.values.email.match(
      /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    );
    return isSameEmails && isEmailValid;
  };
  return (
    <div className="login-form">
      <div className="login-form__header">
        <img src={Logo} alt="Logo" className="login-form__logo"/>
        <div className="login-form__titles">
          <div className="login-form__title">{StringStore.authentication.forgotPassword.title}</div>
          <div className="login-form__subtitle">{StringStore.authentication.forgotPassword.description}</div>
        </div>
      </div>
      <div className="login-form__inputs">
        <div className="login-form__inputs__input-combo">
          <label htmlFor="email" className='login-form__inputs__label'>
            {StringStore.authentication.forgotPassword.email}
          </label>
          <InputText 
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            aria-describedby="email-help" 
            className='login-form__inputs__text-input'
            placeholder={StringStore.authentication.forgotPassword.emailPlaceholder}
          />
        </div>
        <div className="login-form__inputs__input-combo">
          <label htmlFor="emailAgain" className='login-form__inputs__label'>
            {StringStore.authentication.forgotPassword.emailAgain}
          </label>
          <InputText 
            name="emailAgain"
            value={formik.values.emailAgain}
            onChange={formik.handleChange}
            aria-describedby="password-help" 
            className='login-form__inputs__text-input'
            placeholder={StringStore.authentication.forgotPassword.emailAgainPlaceholder}
          />
          <div id="password-help" className='login-form__inputs__help'>
            {StringStore.authentication.forgotPassword.navigationLabel}
            <div className='login-form__inputs__click' onClick={()=>handleClick(FormState.Login)}>
              {StringStore.common.clickHere}
            </div>
          </div>
        </div>
        <Button 
          label={StringStore.authentication.forgotPassword.buttonLabel}
          onClick={() => {
            formik.handleSubmit();
          }}
          raised 
          className="login-form__inputs__button"
        />
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
